import { useAuth } from "@/contexts/AuthContext";
import { OperatorDashboard } from "./OperatorDashboard";
import { DesignerDashboard } from "./DesignerDashboard";

interface RoleDashboardProps {
  children: React.ReactNode; // Dashboard por defecto (admin/manager)
}

export function RoleDashboard({ children }: RoleDashboardProps) {
  const { userRole } = useAuth();

  // Determinar qué dashboard mostrar según el rol
  switch (userRole) {
    case "operator":
    case "operario":
      return <OperatorDashboard />;

    case "designer":
    case "diseno":
    case "cnc":
      return <DesignerDashboard />;

    case "admin":
    case "manager":
    case "gerente":
    default:
      // Para admin/manager/default, mostrar el dashboard completo
      return <>{children}</>;
  }
}

// Hook para verificar si el usuario tiene un rol específico
export function useHasRole(roles: string | string[]) {
  const { userRole } = useAuth();
  const rolesArray = Array.isArray(roles) ? roles : [roles];
  return userRole ? rolesArray.includes(userRole) : false;
}

// Componente para mostrar contenido solo para ciertos roles
interface RoleGateProps {
  roles: string | string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function RoleGate({ roles, children, fallback = null }: RoleGateProps) {
  const hasRole = useHasRole(roles);
  return hasRole ? <>{children}</> : <>{fallback}</>;
}
